import { Component, ViewEncapsulation, Input } from "@angular/core";
import { RoblexModalFooterAlign } from '../../../enum/modal-footer-align.enum';

@Component({
    selector: "roblex-modal-footer",
    templateUrl: "./modal-footer.component.html",
    styleUrls: ["./modal-footer.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class ModalFooterComponent {
    /**
     * Input  of modal footer component
     */
    @Input() contentAlign: string = RoblexModalFooterAlign.stretch;
    /**
     * Creates an instance of modal footer component.
     */
    constructor() {}
    /**
     * Customs class align
     * @returns  any
     */
    customClassAlign() {
        switch (this.contentAlign) {
            case RoblexModalFooterAlign.center:
                return { "roblex-footer-center": true };

            case RoblexModalFooterAlign.end:
                return { "roblex-footer-end": true };

            case RoblexModalFooterAlign.start:
                return { "roblex-footer-start": true };

            case RoblexModalFooterAlign.stretch:
                return { "roblex-footer-stretch": true };

            default:
                break;
        }
        return {};
    }
}
